import { z } from 'zod';

export interface Masjid {
  readonly id: string;
  readonly adminId: string;
  readonly name: string;
  readonly city: string | null;
  readonly address: string | null;
  readonly latitude: number | null;
  readonly longitude: number | null;
  readonly createdAt: string;
}

const masjidRowSchema = z.object({
  id: z.string(),
  admin_id: z.string(),
  name: z.string(),
  city: z.string().nullable(),
  address: z.string().nullable(),
  latitude: z.number().nullable(),
  longitude: z.number().nullable(),
  created_at: z.string(),
});

export function mapMasjid(row: unknown): Masjid {
  const r = masjidRowSchema.parse(row);
  return {
    id: r.id,
    adminId: r.admin_id,
    name: r.name,
    city: r.city,
    address: r.address,
    latitude: r.latitude,
    longitude: r.longitude,
    createdAt: r.created_at,
  };
}

export interface MasjidCreateInput {
  readonly adminId: string;
  readonly name: string;
  readonly city: string | null;
  readonly address: string | null;
  readonly latitude: number | null;
  readonly longitude: number | null;
}

export function toMasjidRow(input: MasjidCreateInput): Record<string, unknown> {
  return {
    admin_id: input.adminId,
    name: input.name,
    city: input.city,
    address: input.address,
    latitude: input.latitude,
    longitude: input.longitude,
  };
}
